import { environment } from '../../../environments/environment';
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
  PublicClientApplication,
} from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';

/**
 * Stub MSAL config used when MS Entra is not the active auth provider.
 * The instance is created but never initialized, so it remains inert.
 */
const msalStubConfig = {
  auth: {
    clientId: 'stub-client-id',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.MemoryStorage,
    storeAuthStateInCookie: false,
  },
};

/**
 * Factory for the MSAL PublicClientApplication instance.
 * Creates a real instance when Entra is the active provider, stub otherwise.
 */
export function msalInstanceFactory(useEntraAuth: boolean): IPublicClientApplication {
  const config = useEntraAuth ? environment.msalConfig : msalStubConfig;
  return new PublicClientApplication(config);
}

/**
 * MSAL Guard configuration – uses Redirect interaction for seamless SSO.
 */
export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.msalScopeUri ? [environment.msalScopeUri] : [],
    },
    loginFailedRoute: '/login',
  };
}

/**
 * MSAL Interceptor configuration – protects all /api/* calls with an Entra token.
 */
export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  if (environment.msalScopeUri) {
    protectedResourceMap.set('/api/', [environment.msalScopeUri]);
  }
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
